<template>
  <div class="wrapper" @click="clickOutSide">
    <side-bar>
      <template slot="topLogo">
        <span class="rounded-circle d-flex flex-column align-items-center">
          <img
            alt="Image placeholder"
            :src="`${publicPath}/img/rcp/${theme}-dashboard-logo.png`"
            style="max-width: 120px;"
          />
        </span>
      </template>

      <template slot="links">
        <!-- <sidebar-item
          v-if="!isSuspend"
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            imageicon: 'dashboard.svg',
          }"
        >
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'E-Wallet',
            path: '/e-wallet',
            imageicon: 'e-wallet.svg',
          }"
        >
        </sidebar-item> -->
        <sidebar-item
          v-if="
            isFirstTime == 'false' &&
            kycApprove &&
            haveCard &&
            !profileStatus &&
            domain_info.merchant_deposit != 1 &&
            domain.indexOf('gvv.oripay.us')===-1
          "
          :link="{
            name: 'Deposit',
            path: '/choose-card',
            imageicon: 'deposit.svg',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="
            isFirstTime == 'false' &&
            kycApprove &&
            haveCard &&
            !profileStatus &&
            isNavActive
          "
          :link="{
            name: 'Transfer',
            path: '/transfer',
            imageicon: 'transfer.svg',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="!isSuspend && isFirstTime == 'false' && !profileStatus"
          :link="{
            name: 'Upload Documents (eKYC)',
            path: kycApprove ? '/kyc-summary' : '/kyc',
            imageicon: 'ekyc.svg',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="
            !isSuspend && isFirstTime == 'false' && kycApprove && !profileStatus
          "
          :link="{
            name: 'Card Management',
            path: '/card-management',
            imageicon: 'card-management.svg',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="!isSuspend"
          :link="{
            name: 'Settings',
            path: '/settings',
            imageicon: 'settings.svg',
          }"
        >
          <sidebar-item
            v-if="isFirstTime == 'false'"
            :link="{
              name: 'Edit Profile',
              path: '/edit-profile',
            }"
          >
          </sidebar-item>

          <sidebar-item
            :link="{
              name: 'Change Password',
              path: '/change-password',
            }"
          >
          </sidebar-item>

          <!-- <sidebar-item
            :link="{
              name: 'Set PIN',
              path: '/change-pin',
            }"
          >
          </sidebar-item> -->

          <sidebar-item
            v-if="isFirstTime == 'false'"
            :link="{
              name: 'System Configuration',
              path: '/system-configuration',
            }"
          >
          </sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="!isSuspend && isFirstTime == 'false' && kycApprove"
          :link="{
            name: 'Report',
            path: '/transaction',
            imageicon: 'report.svg',
          }"
        >
        </sidebar-item>

        <!-- <sidebar-item
            v-if="isFirstTime == 'false' && kycApprove && haveCard && !profileStatus && domain_info.merchant_deposit != 1"
            :link="{
              name: 'Account',
              path: '/account',
              imageicon: 'account.svg',
            }"
          >
        </sidebar-item> -->

        <!-- <sidebar-item
          :link="{
            name: 'About',
            path: '/about',
            imageicon: 'about',
          }"
        >
        </sidebar-item> -->

        <sidebar-item
          v-if="!isSuspend && chat == 1"
          :link="{
            name: 'Customer Service',
            path: '/cs',
            imageicon: 'customer-service.svg',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="!isSuspend && chat == 1"
          :link="{
            name: 'FAQs',
            path: '/faq',
            imageicon: 'faq.svg',
          }"
        >
        </sidebar-item>


        <sidebar-item
          :link="{
            name: 'Logout',
            path: '/logout',
            imageicon: 'logout.svg',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <!-- <TopSideMenu class="mb-2"></TopSideMenu> -->
        <notifications position="top right" />
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view ref="currentPage"></router-view>
        </fade-transition>

        <floating-chat-icon
          v-if="chat == 1 && !visibleChat"
          icon
          @toggle-chat="toggleChat"
          :isActive="showChat"
        ></floating-chat-icon>
        <floating-chat
          :isFloating="true"
          v-if="!visibleChat && showChat && chat == 1"
          @toggle-chat="toggleChat"
          @is-connect="isReadyToChat"
        >
        </floating-chat>
      </div>
    </div>

    <b-modal
      id="modal-scarm-alert"
      :title="`${$t('Reminder')}`"
      @hide="$bvModal.hide('modal-scarm-alert')"
      hide-footer
    >
      <template #modal-title>
        <h3 class="text-title fz-18">{{ $t("Reminder") }}</h3>
      </template>
      <div class="mt-4 text-center">
        <img
          alt="Image placeholder"
          :src="`${publicPath}/img/rcp/scam_alert.gif`"
          class="w-100"
          style="max-width: 320px"
        />
        <h2>Scam Alert</h2>
        <p class="mx-4">
          Members of the public are reminded not to disclose your personal
          identification numbers (PIN) and passwords to third parties under any
          circumstance. RCPAY LIMITED will NEVER request for personal financial
          information or confirmation of Mastercard transactions through
          telephone calls, emails or SMS. Please do not respond to such query.
          <br />
          Do NOT reveal your personal financial information.
        </p>
        <button
          class="btn btn-orange my-4"
          @click="$bvModal.hide('modal-scarm-alert')"
        >
          {{ $t("I understand") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Common from "@/services/Common";
import Member from "@/services/Member";
import TopSideMenu from "@/components/Navbar/TopSideMenu";
import FloatingChatIcon from "@/components/Chat/FloatingChatIcon.vue";
import FloatingChat from "@/components/Chat/Chat.vue";
import { FadeTransition } from "vue2-transitions";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      translation: process.env.VUE_APP_TRANSLATION,
      company_logo: "",
      domain_info: {},
      list_logo: JSON.parse(process.env.VUE_APP_COMPANY_LOGO),
      chat: process.env.VUE_APP_CHAT,
      isDebug: process.env.VUE_APP_DEBUG_MODE,
      userListDebug: process.env.VUE_APP_LIST_USER_DEBUG,
      suspendDomain: process.env.VUE_APP_SUSPEND_DOMAIN,
      theme:process.env.VUE_APP_THEME,
      isSuspend: false,
      isNavActive: false,
      visibleChat: false,
      showChat: false,
      domain: process.env.VUE_APP_CURRENT_DOMAIN
        ? process.env.VUE_APP_CURRENT_DOMAIN
        : location.protocol + "//" + window.location.hostname,
      kyc_data: {
        poi: [
          {
            id: 1,
            name: "Identity card",
            list: [{ type: 2 }, { type: 3 }],
          },
          {
            id: 2,
            name: "Passport",
            list: [{ type: 4 }],
          },
        ],
        poa: [
          {
            id: 1,
            name: "Driving license",
            list: [{ type: 5 }, { type: 6 }],
          },
          {
            id: 2,
            name: "Utility bill",
            list: [{ type: 7 }],
          },
          {
            id: 3,
            name: "Bank statement",
            list: [{ type: 8 }],
          },
        ],
        selfie: [
          {
            id: 1,
            name: "Self Portrait",
            list: [{ type: 1 }],
          },
        ]
      },
      isFirstTime: false,
      kycStatus: false,
      kycApprove: false,
      profileStatus: true,
      haveCard: false,
      list_contry_blocked:[],
    };
  },
  components: {
    FadeTransition,
    TopSideMenu,
    FloatingChatIcon,
    FloatingChat,
  },
  methods: {
    isReadyToChat(is_connect) {
      this.$refs["currentPage"].isLoading = !is_connect;
    },
    toggleChat() {
      this.showChat = !this.showChat;
    },
    clickOutSide(evt) {},
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    checkKyc(current) {
      Common.getKyc()
        .then((response) => {
          const data = response.data.data;
          let approve = true;

          Object.keys(this.kyc_data).forEach((key) => {
            // console.log(key);
            const doc_list = this.kyc_data[key][current[key]].list;
            // console.log(doc_list);
            for (let i = 0; i < doc_list.length; i++) {
              // console.log(doc_list[i].type);
              // console.log(data.kyc[doc_list[i].type]);
              if (data.kyc[doc_list[i].type].status != 1) {
                approve = false;
              }
            }
          });

          if (approve) {
            this.kycApprove = true;
            this.kycStatus = false;
          } else {
            this.kycStatus = true;
          }

          this.checkRedirect();
        })
        .catch((err) => {
          this.checkError(err);
        });
    },
    checkRedirect() {
      
      this.init = localStorage.getItem("init");
      if (this.isSuspend) {
        localStorage.removeItem("init");
        this.$router.push({ path: "/suspend" });
      } else {
        if (this.init == "true") {
          // this.$bvModal.show("modal-scarm-alert");
        }

        if (this.isFirstTime != "false") {
          localStorage.removeItem("init");
          if (this.$route.name != "change-password") {
            this.$router.push({ path: "/change-password" });
          }
        } else if (this.profileStatus) {
          if (this.$route.name != "edit-profile") {
            this.$router.push({ path: "/edit-profile" });
          }
        } else if (this.kycStatus && !this.profileStatus) {
          localStorage.removeItem("init");
          if (this.$route.name != "kyc" && this.$route.name != "kyc-summary") {
            if (this.kycApprove) {
              this.$router.push({ path: "/kyc-summary" });
            } else {
              this.$router.push({ path: "/kyc" });
            }
          }
        } else if (
          !this.haveCard &&
          this.kycApprove &&
          this.$route.name != "card-management" &&
          this.$route.name != "card-management-2" &&
          this.$route.name != "order-card" &&
          this.$route.name != "fill-in-details" &&
          this.$route.name != "complete"
        ) {
          localStorage.removeItem("init");
          this.$router.push({ path: "/card-management" });
        } else if (
          !this.profileStatus &&
          this.kycApprove &&
          this.haveCard &&
          this.init == "true"
        ) {
          localStorage.removeItem("init");
          this.$router.push({ path: "/transaction" });
        } else if (
          this.domain_info.merchant_deposit == 1 &&
          this.$route.name == "deposit"
        ) {
          localStorage.removeItem("init");
          this.$router.push({ path: "/" });
        } else {
          localStorage.removeItem("init");
        }
      }
    },
    getProfile() {
      this.isFirstTime = localStorage.getItem("isFirstTime");

      Common.profile()
        .then((response) => {
          if (response.status == 200) {
            const profile = response.data.data;

            if (this.suspendDomain.includes(profile.domain)) {
              this.isSuspend = true;
            }

            if (
              this.userListDebug.includes(profile.username.toUpperCase()) &&
              this.isDebug == 1
            ) {
              this.isNavActive = true;
            }

            const hostname = process.env.VUE_APP_CURRENT_DOMAIN
              ? process.env.VUE_APP_CURRENT_DOMAIN
              : window.location.hostname;

            if (profile.domain.indexOf(hostname) == -1 && this.domain == 1) {
              localStorage.removeItem("token");
              localStorage.removeItem("isFirstTime");
              window.parent.location.href = profile.domain;
            } else {
              if (profile.fullname == null || (this.list_contry_blocked && this.list_contry_blocked.includes(profile.country_code))) {
                this.profileStatus = true;
              } else {
                
                this.profileStatus = false;
              }

              if (
                this.translation == 1 &&
                profile.language &&
                profile.language != null
              ) {
                // localStorage.setItem("lang", profile.language);
                // localStorage.setItem("lang-key", profile.language);
              } else {
                // localStorage.setItem("lang", "en-EN");
                // localStorage.setItem("lang-key", "en-EN");
              }

              if (
                profile.doc_type != null &&
                profile.poa_type != null &&
                profile.doc_type > 0 &&
                profile.poa_type > 0
              ) {
                this.checkKyc({
                  poi: parseInt(profile.doc_type) - 1,
                  poa: parseInt(profile.poa_type) - 1,
                  selfie: 0,
                });
              } else {
                this.kycStatus = true;
                this.checkRedirect();
              }
            }
          }
        })
        .catch((err) => {
          this.checkError(err);
        });
    },
    inIframe: function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    setChatVisible(page) {
      if (page == "customer-service") {
        this.visibleChat = true;
      } else {
        this.visibleChat = false;
      }
    },
    getCountry(){
      let self = this;
      Common.countries().then((response) => {
        if (response.status == 200) {
          self.list_contry_blocked = [];
          const countries = response.data.data;

          countries.forEach(item => {
            if(item.is_blocked == 1){
              self.list_contry_blocked.push(item["iso2"]);
            }
          });

          self.getProfile();
        }
      });
    },
    checkError(err) {
      try {
        const response = err.response;
        if (response.status == 401 && response.data.name == "Unauthorized") {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        // console.log(err);
      }
    },
  },
  computed: {
    pageTitle() {
      return `Dashboard - ${process.env.VUE_APP_COMPANY_NAME}`;
    }
  },
  mounted() {
    document.title = this.pageTitle;

    const domain_url = process.env.VUE_APP_CURRENT_DOMAIN
      ? process.env.VUE_APP_CURRENT_DOMAIN
      : location.protocol + "//" + window.location.hostname;

    Object.keys(this.list_logo).forEach((key) => {
      if (domain_url.indexOf(key) != -1) {
        this.company_logo = this.list_logo[key];
      }
    });

    Member.domain()
      .then((response) => {
        if (response.status == 200) {
          this.domain_info = response.data.data;
        }
      })
      .catch((err) => {
        this.checkError(err);
      });

    const handleCardData = (card) => {
      for (let i = 0; i < card.length; i++) {
        if (card[i]["status"] == 1) {
          this.haveCard = true;
          break;
        }
      }
      this.getCountry();
    };

    Common.card_active({
      onUpdate: handleCardData,
    })
      .then((response) => {
        if (response.status === 200) {
          handleCardData(response.data.data);
        }
      })
      .catch((err) => {
        this.checkError(err);
      });

    this.initScrollbar();
    this.setChatVisible(this.$route.name);
  },
  watch: {
    $route(to, from) {
      this.setChatVisible(to.name);
    },
  },
};
</script>
<style lang="scss">
.collapse {
  margin-top: 12px;
}
.modal-title {
  display: flex !important;
  justify-content: space-between !important;
}
</style>
